import SellerLayout from "@/components/SellerLayout";
import { PageHeader } from "@/components/ui-system";
import WebhookConfig from "@/components/b2c/WebhookConfig";

const B2CWebhook = ({ user, onLogout }) => (
  <SellerLayout user={user} onLogout={onLogout}>
    <div className="space-y-6 w-full max-w-3xl">
      <PageHeader
        title="Tracking Webhook"
        subtitle="Get a signed callback on every tracking update for your B2C orders"
      />
      <WebhookConfig />
    </div>
  </SellerLayout>
);

export default B2CWebhook;
